const ABSOLUTE_URL_PATTERN = /^(?:[a-z]+:)?\/\//i;
const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

const normalizeAttachmentRelativePath = (pathValue) => {
  let normalizedPath = String(pathValue || "").trim().replace(/\\/g, "/");
  normalizedPath = normalizedPath.replace(/^\/+/, "");

  // Keep only the path under attachments when legacy values include absolute/extra prefixes.
  const attachmentsToken = "/attachments/";
  const lowerPath = normalizedPath.toLowerCase();
  const tokenIndex = lowerPath.indexOf(attachmentsToken);
  if (tokenIndex >= 0) {
    normalizedPath = normalizedPath.slice(tokenIndex + attachmentsToken.length);
  }

  normalizedPath = normalizedPath.replace(/^(attachments\/)+/i, "");

  // Legacy values can sometimes include full Windows paths; keep filename in that case.
  if (normalizedPath.includes(":/")) {
    normalizedPath = normalizedPath.split("/").pop() || normalizedPath;
  }

  return `attachments/${normalizedPath}`;
};

export const resolveMediaUrl = (path, { attachmentRoot = false, absolute = false } = {}) => {
  if (!path) {
    return null;
  }

  if (typeof path !== "string") {
    return path;
  }

  const trimmedPath = path.trim();
  if (!trimmedPath) {
    return null;
  }

  if (trimmedPath.startsWith("data:") || trimmedPath.startsWith("blob:")) {
    return trimmedPath;
  }

  if (ABSOLUTE_URL_PATTERN.test(trimmedPath)) {
    try {
      const parsedUrl = new URL(trimmedPath);
      if (attachmentRoot) {
        const attachmentRelativePath = normalizeAttachmentRelativePath(parsedUrl.pathname);
        const relativeUrl = `/${attachmentRelativePath}`;
        return absolute ? `${window.location.origin}${relativeUrl}` : relativeUrl;
      }

      // If legacy data points to localhost (or same host with old port), map to current origin.
      if (
        LOCAL_HOSTNAMES.has(parsedUrl.hostname) ||
        parsedUrl.hostname === window.location.hostname
      ) {
        const relativeUrl = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
        return absolute ? `${window.location.origin}${relativeUrl}` : relativeUrl;
      }

      return trimmedPath;
    } catch {
      // Fall through to generic normalization.
    }
  }

  let normalizedPath = trimmedPath.replace(/\\/g, "/");
  normalizedPath = normalizedPath.replace(/^\/+/, "");

  if (attachmentRoot) {
    normalizedPath = normalizeAttachmentRelativePath(normalizedPath);
  }

  const relativeUrl = `/${normalizedPath}`;
  return absolute ? `${window.location.origin}${relativeUrl}` : relativeUrl;
};